import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';

// Корневые экраны: с них некуда возвращаться — Telegram показывает «крестик».
// Корень один — первый экран (/main). Из каталога стрелка возвращает на него.
const ROOT_ROUTES = ['/main', '/favorites', '/cart', '/profile', '/entry', '/region-select'];

export const useTelegramBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isRoot = ROOT_ROUTES.some(
      (tab) => location.pathname === tab || location.pathname === '/'
    );

    if (isRoot) {
      WebApp.BackButton.hide();
    } else {
      WebApp.BackButton.show();
    }

    const handleBack = () => {
      // Каталог и шеринг открываются с первого экрана карточками — туда и возвращаем,
      // иначе история увела бы на предыдущий товар или подборку.
      if (location.pathname === '/home' || location.pathname === '/sharing') navigate('/main');
      else navigate(-1);
    };

    WebApp.BackButton.onClick(handleBack);

    return () => {
      WebApp.BackButton.offClick(handleBack);
    };
  }, [location.pathname, navigate]);
};
